import { render } from "./intermedio_ingles.vue?vue&type=template&id=12ae1651&scoped=true"
import script from "./intermedio_ingles.vue?vue&type=script&lang=js"
export * from "./intermedio_ingles.vue?vue&type=script&lang=js"

import "./intermedio_ingles.vue?vue&type=style&index=0&id=12ae1651&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ae1651"]])

export default __exports__